import { Module } from 'vuex'
import { RootState } from '@/store'
import { mutations } from '@/store/modules/voice/mutations'
import { IVoiceState, initialState } from '@/store/modules/voice/state'

export * from '@/store/modules/voice/state'

export const store: Module<IVoiceState, RootState> = {
  state: initialState,
  mutations
}
